<template>
    <div class="take-picture" :style="{ '--buttonColor': buttonColor }">
        <input type="file" accept="image/*" capture="camera" @change="handleCapture($event)" />
        <button><slot></slot></button>
    </div>
</template>

<script>
export default {
    props: {
        fileErrorTitle: String,
        fileErrorMessage: String,
        buttonColor: {
            type: String,
            required: false,
            default: '#555'
        }
    },
    data() {
        return {
            file: null
        };
    },
    watch: {
        file(curr) {
            this.$emit('input', curr);
        },
    },
    methods: {
        handleCapture(e) {
            let input = e.target.files[0];

            if (this.validateFileType(input)) {
                const reader = new FileReader();

                reader.onload = file => this.$emit('load', file.target.result);
                reader.readAsDataURL(input);
            }
            else {
                this.$swal({
                    title: this.fileErrorTitle,
                    text: this.fileErrorMessage,
                    icon: 'error'
                });
            }
        },
        validateFileType(input) {
            let valid = false;
            let fileTypeAllow = ['image/jpeg', 'image/png'];

            if (input != '' && input != null && typeof input != 'undefined') {
                for (var index = 0; index < fileTypeAllow.length; index++) {
                    if (input.type === fileTypeAllow[index]) {
                        valid = true;
                    }
                }

                if (!valid) {
                    this.error.fileType = true;
                }
            }
            else {
                valid = true;
            }

            return valid;
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

$buttonColor: var(--buttonColor);

.take-picture {
    position: relative;

    input {
        position: absolute;
        z-index: 2;
        width: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: 0;
        opacity: 0;
        cursor: pointer;
    }
    
    button {
        position: relative;
        cursor: pointer;
        z-index: 1;
        width: 100%;
        height: auto;
        margin: 0;
        padding: 8px 5px;
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        color: #fff;
        background-color: $buttonColor;
        border: none;
    }
}
</style>